import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Badge, Box, Tabs } from "@mantine/core"

import { Container, LayoutStandard } from "components";
import { AuthorityConstants, ServiceConstants } from "constant";
import { displayClasses } from "styles";
import { AppUtils } from "utils";

import CardNewList from "./new";
import CardCrmList from "./crm";
import { IRootState } from "config/redux";
import { CardService } from "services";

const TABS = {
  NEW: "new",
  CRM: "crm",
}

const { REQUEST_CARDS_STATS_ID } = ServiceConstants;

const CardListPage = () => {
  const { t } = useTranslation();
  const serviceObject = useSelector((state: IRootState) => state.service.object[REQUEST_CARDS_STATS_ID]);
  const [stats, setStats] = useState({
    'NEW': undefined,
    'IN_CRM': undefined
  });

  useEffect(() => {
    CardService.cardsStats();
  }, []);

  useEffect(() => {
    AppUtils.resolveServiceObject(serviceObject, REQUEST_CARDS_STATS_ID, setStats);
  }, [serviceObject]);

  return (
    <LayoutStandard
      authority={AuthorityConstants.ROLE_CC}
      title={AppUtils.composeTabTitle(t('card.list.title'))}
      >
      <Container>
        <Tabs defaultValue={TABS.NEW} keepMounted={false} variant={'pills'}>
          <Tabs.List>
            <Tabs.Tab value={TABS.NEW} className={displayClasses.tabList}>
              {t('card.list.tab.' + TABS.NEW)}
              <BadgeNumber value={stats.NEW} />
            </Tabs.Tab>
            <Tabs.Tab value={TABS.CRM} className={displayClasses.tabList}>
              {t('card.list.tab.' + TABS.CRM)}
              <BadgeNumber value={stats.IN_CRM} />
            </Tabs.Tab>
          </Tabs.List>
          <Tabs.Panel value={TABS.NEW} className={displayClasses.tabContent}><CardNewList /></Tabs.Panel>
          <Tabs.Panel value={TABS.CRM} className={displayClasses.tabContent}><CardCrmList /></Tabs.Panel>
        </Tabs>
      </Container>
    </LayoutStandard>
  )
}

const BadgeNumber = ({ value }: { value: number | undefined }) => (
  value === undefined
    ? <></>
    : <Box style={{ marginLeft: 8, position: 'relative', bottom: 2, display: 'inline' }}>
        <Badge size={'sm'} bg={'none'} c={'gray'} style={{ borderColor: 'gray' }}>{value}</Badge>
      </Box>
)

export default CardListPage;